import { render, staticRenderFns } from "./PostcodeSearch.vue?vue&type=template&id=8e321454&scoped=true&"
import script from "./PostcodeSearch.vue?vue&type=script&lang=js&"
export * from "./PostcodeSearch.vue?vue&type=script&lang=js&"
import style0 from "./PostcodeSearch.vue?vue&type=style&index=0&id=8e321454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e321454",
  null
  
)

export default component.exports